'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:AppLicensesController
 * @description
 * # ProspectNewCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('AppLicensesNewCtrl', [
    '$scope', '$rootScope', 'AppLicense', '$state', 'Client', 'ProductCatalog', 'toaster',
    function ($scope, $rootScope, AppLicense, $state, Client, ProductCatalog, toaster) {
    $rootScope.rootPath = {
      url: '',
      id: '',
    };
    let oneYearFromNow = new Date();
    oneYearFromNow.setFullYear(oneYearFromNow.getFullYear());
    $scope.appLicenseHash = {
      'app_license': {
        'client_id': '',
        'entity_name': '',
        'entity_rfc': '',
        'environment': 'prod',
        'num_licenses': 1,
        'license_valid_until': oneYearFromNow,
        'license_type': "rent",
        'has_mesa_electronica_license_key': false,
        'product_catalog_id': '',
        'modules': {}
      }
    };

    $scope.selectedClient = {}

    $scope.selectedProduct = {}

    $scope.licenseTypeList = [
      {
        name: 'Usuarios Concurrentes',
        id: 2
      },
      {
        name: 'Usuarios Nombrados',
        id: 1
      },
    ];

    $scope.saveLicense = function() {
      if ($scope.selectedProduct && $scope.selectedProduct.name !== 'Siglo CD') {
        $scope.appLicenseHash.app_license.has_mesa_electronica_license_key = false;
      }
      AppLicense.save($scope.appLicenseHash).then((response) => {
        toaster.pop('success', 'Licencia', 'Se creó exitosamente');
        $state.go('app.app_licenses.list');
      }).catch((err) => {
        toaster.pop('error', 'Licencia', err.data.errors[0]);
        AppLicense.baseError(err);
      })
    };

    $scope.populateEntity = function() {
      $scope.appLicenseHash.app_license.client_id = $scope.selectedClient.id
      $scope.appLicenseHash.app_license.entity_name = $scope.selectedClient.complete_name
      $scope.appLicenseHash.app_license.entity_rfc = $scope.selectedClient.rfc
    };

    $scope.populateModules = function() {
      $scope.appLicenseHash.app_license.product_catalog_id = $scope.selectedProduct.id
      // Populate Modules since they don't exist yet
      // Emission, Reception, Conciliation
      $scope.selectedProduct.modules = {
        'Emission': false,
        'Reception': false,
        'Conciliation': false
      }
      $scope.appLicenseHash.app_license.modules = $scope.selectedProduct.modules;
    }

    const getAllParams =  (() => {
        Client.index({params: {per_page: 'all', by_column: {"column": "name", "order": "ASC"}}}).then((response) => {
            $scope.clients = response.data.clients;
            return;
          }).catch((error) => {
            // TODO: Show the notification that the clients were unable to get
            console.log(error);
        });
        ProductCatalog.index({params: {per_page: 'all', by_column: {"column": "name", "order": "ASC"}}}).then((response) => {
            $scope.products = response.data.products;
            return;
          }).catch((error) => {
            // TODO: Show the notification that the clients were unable to get
            console.log(error);
          });
    });

    getAllParams();

}]);
